import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserContextService } from '@benefitsui/app/services/user-context/user-context.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-no-access-page',
  templateUrl: './no-access-page.component.html',
  styleUrls: ['./no-access-page.component.scss']
})
export class NoAccessPageComponent implements OnInit {
  constructor(
    private router: Router,
    private userContextService: UserContextService,
    private location: Location
  ) {}

  async ngOnInit(): Promise<void> {
    const userContext = this.userContextService.get();
    switch (userContext.symClass.toLowerCase()) {
      case 'employee':
        break;
      case 'distributor':
        break;
      case 'sponsor':
        break;
      default:
        await this.router.navigate(['error'], { queryParamsHandling: 'preserve', replaceUrl: true });
        return;
    }
  }
}
